var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['fish upload']},[_vm._t("content"),_c('div',{staticClass:"upload-trigger",style:(_vm.triggerStyle),on:{"click":_vm.clickHandler}},[_c('input',{ref:"input",attrs:{"type":"file","multiple":_vm.multiple,"accept":_vm.accept},on:{"change":_vm.changeHandler}}),_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }